import Joi from 'joi';
import i18n from '../i18n';

/** A new password and its confirmation, as Sign Up and the reset link ask for them. */
export const newPasswordSchema = () => ({
  // Each pattern's name is its whole message, since Spanish words "at least one" per noun
  password: Joi.string()
    .min(8)
    .max(255)
    .pattern(/[A-Z]/, i18n.t('auth.passwordNeedsUppercase'))
    .pattern(/[0-9]/, i18n.t('auth.passwordNeedsNumber'))
    .pattern(/[^a-zA-Z0-9]/, i18n.t('auth.passwordNeedsSpecial'))
    .required()
    .label('Password')
    .messages({ 'string.pattern.name': '{#name}' }),
  confirmPassword: Joi.any()
    .valid(Joi.ref('password'))
    .required()
    .messages({ 'any.only': i18n.t('auth.passwordsMatch') })
    .label('Passwords'),
});
